import { Injectable } from '@angular/core';
import {BaseService, httpOptions} from "@core/service/base.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService extends BaseService{

  private url = 'api/purOrder';
  private priceUrl = 'api/purPrice/condition';//根据相关信息获取订单价格信息
  private orderValidUrl = 'api/purOrder/valid';//校验订单
  private orderValidShareUrl = 'api/purOrder/validShare';//校验订单
  private orderSubmitUrl = 'api/purOrder/flow';//订单提交
  private isSupplierUrl = 'api/supplier/is-supplier';//判断登陆账户是否为供应商
  private requestViewUrl = 'api/workflowRequest/requestView';//判断当前操作用户是否在流程内
  // private delete
  constructor(http: HttpClient) {
    super(http);
  }
  getUrl(): string {
    return this.url;
}

//  根据订单号获取订单详情
  getOrderDetailByOrderNo(orderNo:string):Observable<any> {
    const url = `${this.getUrl() + '/find'}/${orderNo}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getOrderDetailByOrderNo`)),
      catchError(this.handleError<any>(`getOrderDetailByOrderNo`))
    );
  }

//  获取价格信息
  getOrderPrice(params):Observable<any> {
    return this.http.post<any>(this.priceUrl, params, httpOptions).pipe(
      tap((object:any) => this.log(`getOrderPrice`)),
      catchError(this.handleError<any>('getOrderPrice'))
    );
  }

//  订单校验
  orderValid(object):Observable<any> {
    return this.http.post<any>(this.orderValidUrl, object, httpOptions).pipe(
      tap((object:any) => this.log(`orderValid =${object}`)),
      catchError(this.handleError<any>('orderValid'))
    );
  }

  //  订单校验份额
  orderValidShare(object):Observable<any> {
    return this.http.post<any>(this.orderValidShareUrl, object, httpOptions).pipe(
      tap((object:any) => this.log(`orderValid =${object}`)),
      catchError(this.handleError<any>('orderValid'))
    );
  }


//  订单提交
  orderSubmit(object):Observable<any> {
    return this.http.post<any>(this.orderSubmitUrl, object, httpOptions).pipe(
      tap((object:any) => this.log(`orderSubmit =${object}`)),
      catchError(this.handleError<any>('orderSubmit'))
    );
  }

  //  获取登陆用户信息，判断登陆用户是否为供应商
  isSupplier():Observable<any> {
    return  this.http.get(this.isSupplierUrl).pipe(
      tap(() => this.log('isSuppliers')),
      catchError(this.handleError('isSuppliers'))
    );
  }

// 判断当前用户是否在当前流程内
  validation(params):Observable<any> {
    return this.http.get(this.requestViewUrl,
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }

  // 刷新批次
  createBatch(purOrderBatchInBean):Observable<any> {
    return this.http.post<any>('api/purOrder/create-batch', purOrderBatchInBean, httpOptions).pipe(
      tap((object:any) => this.log(`刷新成功`)),
      catchError(this.handleError<any>('刷新失败'))
    );
  }

  // 初始化数据
  orderCreateInit(purOrderInitBean):Observable<any> {
    return this.http.post<any>('api/purOrder/init-bean', purOrderInitBean, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }

  // 查询价格
  getValidSrmPrice(srmPriceGetBean):Observable<any> {
    return this.http.post<any>('api/purOrder/valid-srm-price', srmPriceGetBean, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }

  // 查询价格
  getValidShare(srmPriceGetBean):Observable<any> {
    return this.http.post<any>('api/purOrder/valid-srm-share', srmPriceGetBean, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }


  // 格子气窗价格查询
  calcLatticePrice(latticePriceAddInBean):Observable<any> {
    return this.http.post<any>('api/purOrder/calc-lattice-price', latticePriceAddInBean, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }

  // 珍珠岩价格查询
  calczhengzhu(latticePriceAddInBean):Observable<any> {
    return this.http.post<any>('api/purOrder/calc-zhengzhu', latticePriceAddInBean, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }

  batchCommit(ids):Observable<any> {
    return this.http.post<any>('api/purOrder/batch-commit', ids, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }


  autoCommit(ids):Observable<any> {
    return this.http.post<any>('api/purOrder/auto-commit', ids, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }

  orderLog(params:HttpParams):Observable<any> {
    return this.http.get<any>('api/purOrder/order-log', {
      headers: httpOptions.headers,
      observe: 'response',//完整数据返回，包括抬头
      params: params
    }).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }

  findPurOrderHistory(orderErpNo,orderItemNo):Observable<any> {
    return this.http.get<any>('api/purOrder/find-pur-order-history/'+orderErpNo+'/'+orderItemNo, {
      headers: httpOptions.headers
    }).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }

  checkOrderDiffField(object):Observable<any> {
    return this.http.post<any>('api/purOrder/check-order-diff', object, httpOptions).pipe(
      tap((object:any) => this.log(`orderSubmit =${object}`)),
      catchError(this.handleError<any>('orderSubmit'))
    );
  }

  // 格子气窗价格查询
  calcVcFlat(latticePriceAddInBean):Observable<any> {
    return this.http.post<any>('api/purOrder/calc-vc-flat', latticePriceAddInBean, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }

  //查询物料BOM
  findMatBom(purMatBom):Observable<any> {
    return this.http.post<any>('api/purOrder/mat-bom', purMatBom, httpOptions).pipe(
      tap((object:any) => this.log(`获得初始数据成功`)),
      catchError(this.handleError<any>('获得初始数据失败'))
    );
  }
  findByErpNo(code: any) : Observable<any> {
    const url = this.getUrl() +'/findOneByErpNo';
    return this.http.post<any>(url, code, httpOptions).pipe(
      tap(_ => this.log(`findOneByErpNo`)),
      catchError(this.handleError<any>('查询出错'))
    );
  }
}
